 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880","metrics":"metrics","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833","account":"account","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-files":"duplicate-files","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","login":"login","media-analysis":"media-analysis","read-book":"read-book","search":"search","settings-users":"settings-users","import-readlists~settings-user":"import-readlists~settings-user","import-readlists":"import-readlists","settings-server~settings-user":"settings-server~settings-user","settings-user":"settings-user","settings-server":"settings-server","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880":"703ec586","metrics":"3d3e3977","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4":"0d8b461a","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01":"df415101","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833":"8c59897b","account":"51f19bd2","browse-book":"210c1fd4","browse-collection":"29f9ee42","browse-collections":"d61e6a0f","browse-libraries":"0c5e395e","browse-readlist":"ea56a5ce","browse-readlists":"f2bcf469","browse-series":"5803eb56","dashboard":"c31a500a","duplicate-files":"f466d6b8","duplicate-pages":"471ee1ff","history":"cb5b59c3","home":"ac6bc8bb","import-books":"c8650f95","login":"785a3c4b","media-analysis":"29100650","read-book":"bdd4a1cd","search":"3831a118","settings-users":"e3bc488f","import-readlists~settings-user":"1f8f06f9","import-readlists":"d98df2b1","settings-server~settings-user":"6bc5482c","settings-user":"b4e4e5b0","settings-server":"93ff8e95","import~media-management~settings":"715f8245","import":"76620c00","media-management":"b3a0f972","settings":"fe9a5f7c","notfound":"55a2d335","welcome":"aa9ed673","startup":"b44e4de3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880":1,"metrics":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833":1,"account":1,"browse-book":1,"browse-collection":1,"browse-collections":1,"browse-libraries":1,"browse-readlist":1,"browse-readlists":1,"browse-series":1,"dashboard":1,"duplicate-files":1,"duplicate-pages":1,"history":1,"home":1,"import-books":1,"login":1,"media-analysis":1,"read-book":1,"search":1,"settings-users":1,"import-readlists~settings-user":1,"import-readlists":1,"settings-server~settings-user":1,"settings-user":1,"settings-server":1,"import~media-management~settings":1,"import":1,"media-management":1,"settings":1,"notfound":1,"welcome":1,"startup":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880","metrics":"metrics","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833","account":"account","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-files":"duplicate-files","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","login":"login","media-analysis":"media-analysis","read-book":"read-book","search":"search","settings-users":"settings-users","import-readlists~settings-user":"import-readlists~settings-user","import-readlists":"import-readlists","settings-server~settings-user":"settings-server~settings-user","settings-user":"settings-user","settings-server":"settings-server","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~5e482880":"aaab1f3f","metrics":"9a757846","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~a445a8b4":"8900c3e4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c6580f01":"a92ebaa2","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~fc9cc833":"172b4612","account":"fa8b94cf","browse-book":"d30e4216","browse-collection":"5709b43e","browse-collections":"c9484332","browse-libraries":"6f00a66a","browse-readlist":"5709b43e","browse-readlists":"c9484332","browse-series":"813285ea","dashboard":"c599acae","duplicate-files":"5ea71554","duplicate-pages":"8bb49e95","history":"be989179","home":"feac2cae","import-books":"9c866f42","login":"7295ecd8","media-analysis":"5ea71554","read-book":"30bb3cf4","search":"c8587143","settings-users":"46a2c713","import-readlists~settings-user":"b9c188cd","import-readlists":"0da29c4d","settings-server~settings-user":"12f8780e","settings-user":"6fa0720b","settings-server":"8f2e3902","import~media-management~settings":"7df717b5","import":"878ad2e3","media-management":"df1b70ce","settings":"878ad2e3","notfound":"5cff8ae2","welcome":"7cc5818c","startup":"7cc5818c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
